import {
    IconAddressBook,
    IconAlertTriangle,
    IconCalendarTime,
    IconCaravan,
    IconChartBarPopular,
    IconCoinEuro,
    IconDatabasePlus,
    IconFileInvoice,
    IconHistory,
    IconHome,
    IconId,
    IconKey,
    IconSettings,
    IconTerminal2,
    IconUserPlus,
    IconUsers,
} from '@tabler/icons-vue';
import { router } from '@inertiajs/vue3';
import { computed, onUnmounted, ref } from 'vue';

export const useAppNavigation = () => {
    const currentRoute = ref(route());

    onUnmounted(
        router.on('navigate', () => {
            currentRoute.value = route();
        }),
    );

    const navigation = computed(() => [
        {
            name: 'Home',
            href: route('dashboard'),
            icon: IconHome,
            current: currentRoute.value.current('dashboard'),
        },
        {
            name: 'Klanten',
            href: route('clients.index'),
            icon: IconAddressBook,
            current: currentRoute.value.current('clients.*'),
        },
        {
            name: 'Voertuigen',
            href: route('vehicles.index'),
            icon: IconCaravan,
            current: currentRoute.value.current('vehicles.*'),
        },
        {
            name: 'Reserveringen',
            href: route('subscriptions.index'),
            icon: IconId,
            current: currentRoute.value.current('subscriptions.*'),
        },
        {
            name: 'Afspraken',
            href: route('appointments.index'),
            icon: IconCalendarTime,
            current: currentRoute.value.current('appointments.*'),
        },
        {
            name: 'Facturen',
            href: route('invoices.index'),
            icon: IconFileInvoice,
            current: currentRoute.value.current('invoices.*'),
        },
        {
            name: 'Betalingen',
            href: route('payments.index'),
            icon: IconCoinEuro,
            current: currentRoute.value.current('payments.*'),
        },
        {
            name: 'Statistieken',
            href: route('metrics.index'),
            icon: IconChartBarPopular,
            current: currentRoute.value.current('metrics.*'),
        },
    ]);

    const adminNavigation = computed(() => [
        {
            name: 'Gebruikers',
            href: route('admin.users.index'),
            icon: IconUsers,
            current: currentRoute.value.current('admin.users.*'),
        },
        {
            name: 'Commando\'s',
            href: route('admin.commands.index'),
            icon: IconTerminal2,
            current: currentRoute.value.current('admin.commands.*'),
        },
        {
            name: 'Logs',
            icon: IconHistory,
            current:
                currentRoute.value.current('admin.activity-log.*')
                || currentRoute.value.current('admin.emails.*')
                || currentRoute.value.current('admin.request-logs.*'),
            children: [
                {
                    name: 'Activiteitenlog',
                    href: route('admin.activity-log.index'),
                    current: currentRoute.value.current('admin.activity-log.*'),
                },
                {
                    name: 'E-mails',
                    href: route('admin.emails.index'),
                    current: currentRoute.value.current('admin.emails.*'),
                },
                {
                    name: 'API-verkeer',
                    href: route('admin.request-logs.index'),
                    current: currentRoute.value.current('admin.request-logs.*'),
                },
            ],
        },
        {
            name: 'Facturatie',
            icon: IconAlertTriangle,
            current:
                currentRoute.value.current('admin.failed-invoices.*')
                || currentRoute.value.current('admin.scheduled-cancellations.*'),
            children: [
                {
                    name: 'Mislukte facturen',
                    href: route('admin.failed-invoices.index'),
                    current: currentRoute.value.current('admin.failed-invoices.*'),
                },
                {
                    name: 'Annuleringen',
                    href: route('admin.scheduled-cancellations.index'),
                    current: currentRoute.value.current('admin.scheduled-cancellations.*'),
                },
            ],
        },
        {
            name: 'API-sleutels',
            href: route('admin.api-keys.index'),
            icon: IconKey,
            current: currentRoute.value.current('admin.api-keys.*'),
        },
    ]);

    const settingsLink = computed(() => ({
        name: 'Instellingen',
        href: route('settings.index'),
        icon: IconSettings,
        current: currentRoute.value.current('settings.*'),
    }));

    const createItems = computed(() => [
        { label: 'Nieuwe klant', icon: IconUserPlus, href: route('clients.create') },
        { label: 'Nieuw voertuig', icon: IconDatabasePlus, href: route('vehicles.create') },
        { label: 'Nieuwe reservering', icon: IconId, href: route('subscriptions.create') },
    ]);

    return {
        navigation,
        adminNavigation,
        settingsLink,
        createItems,
    };
};
